import { defineStore } from 'pinia';
import axios from '@/stores/interceptor';
import { ApiRoutes } from '@/api/ApiRoutes';
import { ref, onMounted } from 'vue';

export const useCommonStore = defineStore('common', () => {
    const globalFeatures = ref<Map<string, boolean>>(new Map());

    const fetchGlobalFeatures = async () => {
        return axios
            .get(ApiRoutes.Common.GetGlobalFeatures)
            .then((response) => {
                globalFeatures.value = new Map(Object.entries(response.data));
            })
            .catch(() => {
                globalFeatures.value = new Map();
            });
    };

    onMounted(() => {
        fetchGlobalFeatures();
    });

    return {
        globalFeatures,
        fetchGlobalFeatures
    };
});
